module.exports = __webpack_public_path__ + "static/media/sunCreme (7).838c766a.jpg";